import store from "../../store/index.js";

export default class BaseMethods {
	// 遮盖转成文字
	static mapCoverToName(cover) {
		let result = '';
		switch (parseInt(cover)) {
			case 0:
				result = '遮左眼';
				break;
			case 1:
				result = '遮右眼';
				break;
			case 2:
				result = '不遮盖';
				break;
		}
		return result;
	}
	
	// 时间转换
	static formatTime(timeDelegate, format) {
		if (!timeDelegate)
			return '';
		var time = new Date(timeDelegate),
			year = time.getFullYear(),
			month = time.getMonth() + 1,
			date = time.getDate(),
			hour = time.getHours(),
			minute = time.getMinutes(),
			second = time.getSeconds(),
			result = '';
		month < 10 && (month = `0${ month }`);
		date < 10 && (date = `0${ date }`);
		hour < 10 && (hour = `0${ hour }`);
		minute < 10 && (minute = `0${ minute }`);
		second < 10 && (second = `0${ second }`);
		if (format == 'yy-mm-dd hh:mm:ss') {
			result = `${ year }-${ month }-${ date } ${ hour }:${ minute }:${ second }`;
		} else {
			result = `${ year }-${ month }-${ date }`;
		}
		return result;
		
		// function _formatTime (time) {
		// 	var year = time.split('T')[0].split('-')[0],
		// 		month = time.split('T')[0].split('-')[1],
		// 		date = time.split('T')[0].split('-')[2],
		// 		hour = time.split('T')[1].split('.')[0].split(':')[0],
		// 		minute = time.split('T')[1].split('.')[0].split(':')[1],
		// 		second = time.split('T')[1].split('.')[0].split(':')[2],
		// 		result = `${ year }/${ month }/${ date } ${ hour }:${ minute }:${ second }`;
		// 	return result;
		// }
	}
	
	// 获取时间
	static getTime(time, type, dateSimbol, timeSimbol) {
		var _time = new Date(time),
			_dateSimbol = dateSimbol || '-',
			_timeSimbol = timeSimbol || ':',
			year = _time.getFullYear(),
			month = _time.getMonth() + 1,
			date = _time.getDate(),
			hour = _time.getHours(),
			minute = _time.getMinutes(),
			second = _time.getSeconds(),
			result = '';
		month < 10 && (month = '0' + month);
		date < 10 && (date = '0' + date);
		hour < 10 && (hour = '0' + hour);
		minute < 10 && (minute = '0' + minute);
		second < 10 && (second = '0' + second);
		
		if (type == 'ymd hms') {
			result = year + _dateSimbol + month + _dateSimbol + date + ' ' + hour + _timeSimbol + minute + _timeSimbol + second;
		} else {
			result = year + _dateSimbol + month + _dateSimbol + date;
		}
		
		return result;
	}
	
	// 导出excel
	static outputExcel(excel_str, excel_name) {
		excel_name = excel_name || '导出';
		var str_blob = new Blob(
			[excel_str], 
			{ type: "text/plain;charset=utf-8" },
		);
		//解决中文乱码问题
		var blob = new Blob(
			[
				String.fromCharCode(0xFEFF),
				str_blob
			], 
			{
				type: str_blob.type
			},
		);
		var object_url = window.URL.createObjectURL(blob);
		var link = document.createElement("a");
		link.href = object_url;
		link.download = `${ excel_name }.csv`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
	
	// 训练计划字母转换为名字
	static mapDocPlanToName(word) {
		var _r = "";
		switch (word) {
			case "A1":
				_r = "视知觉训练";
				break;
			case "B1":
				_r = "固定翻转拍";
				break;
			case "B2":
				_r = "大小字母表";
				break;
			case "B3":
				_r = "镜片阅读";
				break;
			case "B4":
				_r = "镜片排序";
				break;
			case "B5":
				_r = "插片翻转拍";
				break;
			case "C1":
				_r = "聚散球";
				break;
			case "C2":
				_r = "集合卡";
				break;
			case "C3":
				_r = "偏心环卡";
				break;
			case "C4":
				_r = "偏心的同心圆卡";
				break;
			case "C5":
				_r = "救生圈卡";
				break;
			case "C6":
				_r = "裂隙尺";
				break;
			case "C7":
				_r = "立体镜";
				break;
			case "C8":
				_r = "红绿矢量图";
				break;
				
			case "D1":
				_r = "脱抑制卡";
				break;
			case "D2":
				_r = "红绿阅读单位";
				break;
			case "D3":
				_r = "卡尔卡片";
				break;
			case "D4":
				_r = "红绿扑克牌";
				break;
			case "D5":
				_r = "单侧实体镜";
				break;
				
			case "E1":
				_r = "双眼视训练";
				break;
				
			case "F1":
				_r = "专注力训练";
				break;
				
			case "G1":
				_r = "串珠子";
				break;
			case "G2":
				_r = "治疗仪";
				break;
				
			case "H1":
				_r = "红色滤光镜";
				break;
			case "H2":
				_r = "光刷";
				break;
			case "H3":
				_r = "红光闪烁";
				break;
				
			case "I1":
				_r = "弱视训练套包";
				break;
			case "I2":
				_r = "斜视训练套包";
				break;
			case "I3":
				_r = "近视防控训练套包";
				break;
			case "I4":
				_r = "视觉功能训练套包";
				break;
		}
		return _r;
	}
	
	// 上传多张图片
	static uploadMultiImg(e, successCallBack, errorCallBack) {
		var files = e.target.files,
			imgs_type = [],
			imgs_name = [],
			imgs_size = [],
			is_next = true,
			imgs_len = files.length,
			loaded_len = 0,
			base64s = [];
		for (let i = 0; i < files.length; i++) {
			// let file = files.item(i);
			let file = files[i];
			imgs_type.push(file.type);
			imgs_name.push(file.name);
			imgs_size.push(file.size);
		}
		// files.forEach(v => {
		// 	imgs_type.push(v.type);
		// 	imgs_name.push(v.name);
		// 	imgs_size.push(v.size);
		// });
		imgs_type.forEach(v => {
			if (v != 'image/png' && v != 'image/jpeg') is_next = false;
		});
		if (is_next) {
			imgs_type = imgs_type.map(v => {
				if (v == 'image/png') {
					return 'png';
				}
				if (v == 'image/jpeg') {
					return 'jpg';
				}
			});
			// const MAX_IMG_SIZE = 1 * 1024 * 1024;
			imgs_size.forEach((v, i) => {
				// if (v > MAX_IMG_SIZE) {
				// 	compress(files[i], (base64) => {
				// 		loaded_len++;
				// 		result.push(base64);
				// 		if (loaded_len >= imgs_len)
				// 			successCallBack && successCallBack(base64, imgs_name);
				// 	});
				// } else {
					var reader = new FileReader();
					reader.onload = function() {
						loaded_len++;
						base64s.push(this.result);
						if (loaded_len >= imgs_len)
							successCallBack && successCallBack(base64s, imgs_type, imgs_name);
					};
					reader.readAsDataURL(files[i]);
				// }
			});
		} else {
			errorCallBack && errorCallBack('请上传png或者jpg图片！！！');
		}
		
		// 图片压缩
		// function _compress(fileObj, callback) {
		// 	try {
		// 		var reader = new FileReader();
		// 		reader.onload = function (e) {
		// 			var image = document.createElement('img');
		// 			image.onload = function () {
		// 				var squareW = 1 * 1024 * 1024 / fileObj.size * this.width,//定义画布大小,也就是图片压缩之后的像素
		// 					squareH = 1 * 1024 * 1024 / fileObj.size * this.height,
		// 					canvas = document.createElement('canvas'),
		// 					context = canvas.getContext('2d'),
		// 					imageWidth = 0, //压缩图片大小
		// 					imageHeight = 0,
		// 					offsetX = 0,
		// 					offsetY = 0,
		// 					data = '';
		// 					canvas.width = squareW;
		// 					canvas.height = squareH;
		// 					context.clearRect(0,0,squareW,squareH);
		// 				if (this.width > squareW) {
		// 					imageWidth = Math.round(squareW);
		// 					imageHeight = squareH;
		// 					offsetX = Math.round((imageWidth-squareW) / 2);
		// 				} else {
		// 					imageHeight = Math.round(squareH);
		// 					imageWidth = squareW;
		// 					offsetY = Math.round((imageHeight - squareH)/2)
		// 				}
		// 				context.drawImage(this, offsetX, offsetY, imageWidth, imageHeight);
		// 				data = canvas.toDataURL('image/jpeg')
		// 				callback(data)
		// 			};
		// 			image.src = e.target.result;
		// 		};
		// 		reader.readAsDataURL(fileObj);
		// 	} catch (e) {
		// 		errorCallBack && errorCallBack('图片压缩失败！！！');
		// 	}
		// }
	}
	
	// 上传文件
	static uploadFile(e, fileType, successCallBack, errorCallBack) {
		let file = e.target.files[0];
		if (file) {
			let type = file.name.split('.')[1];
			if (type != fileType) {
				errorCallBack(`请上传后缀名为${ fileType }的文件！`);
				return false;
			}
			let data = new FormData();
			data.append('doc', file);
			successCallBack(data);
		} else {
			errorCallBack(`请上传后缀名为${ fileType }的文件！`);
		}
	}
	
	// 获取电脑dpi
	static getDpi() {
		var arrDPI = new Array;
		if (window.screen.deviceXDPI) {
			arrDPI[0] = window.screen.deviceXDPI;
			arrDPI[1] = window.screen.deviceYDPI;
		} else {
			var tmpNode = document.createElement("DIV");
			tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
			document.body.appendChild(tmpNode);
			arrDPI[0] = parseInt(tmpNode.offsetWidth);
			arrDPI[1] = parseInt(tmpNode.offsetHeight);
			tmpNode.parentNode.removeChild(tmpNode);
		}
		return arrDPI;
	}
	
	// 从两个数组中取出不同元素
	static getDiffFromDoubleArr(arr1, arr2) {
		let result = [];
		arr1.forEach(v1 => {
			let _falg = false;
			let _item = v1;
			arr2.forEach(v2 => {
				v1 == v2 && (_falg = true);
			});
			!_falg && (result.push(_item));
		});
		return result;
	}
	
	// 性别转为汉字
	static mapSexToText(sex) {
		let text = '';
		sex == 0 && (text = '男');
		sex == 1 && (text = '女');
		return text;
	}
	
	// 把i练助手分类id转为文字
	static mapIAssistantSortIdToLabel(id) {
		let text = '';
		store.state.iAssistantSortType.forEach(v => {
			id == v.id && (text = v.label);
		});
		return text;
	}
	
	// 把i练助手科普分类id转为文字
	static mapIAssistantScienceIdToLabel(id) {
		let text = '';
		store.state.iAssistantScienceType.forEach(v => {
			id == v.id && (text = v.label);
		});
		return text;
	}
}